import { PaginatedResponse, WithListParams } from '@/types/pagination'
import { Application, ApplicationType } from '../types/app'
import { vpApi } from './vpApi'

export type ApplicationListParams = WithListParams<{
  application_type?: ApplicationType
}>

export const getApplicationList = async (params?: ApplicationListParams) => {
  const res = await vpApi.get<PaginatedResponse<Application[]>>(
    `/v1/applications/`,
    {
      params
    }
  )

  return res.data
}

const getApplicationDetails = async (id: string) => {
  const res = await vpApi.get<Application>(`/v1/applications/${id}/`)
  return res.data
}

type ApplicationCreatePayload = Pick<Application, 'name' | 'application_type'>

const createApplication = (payload: ApplicationCreatePayload) => {
  return vpApi.post<Application>('/v1/applications/', payload)
}

type UpdateApplicationParams = {
  id: string
  data: Pick<Application, 'name'>
}

const updateApplication = ({ id, data }: UpdateApplicationParams) => {
  return vpApi.patch(`/v1/applications/${id}/`, data)
}

const deleteApplication = (id: string) => {
  return vpApi.delete(`/v1/applications/${id}/`)
}

export const applicationApi = {
  getApplicationList,
  getApplicationDetails,
  createApplication,
  updateApplication,
  deleteApplication
}
